<template>
  <div>
    <form>
      <div class="vx-row mb-4">
        <div class="vx-col w-full">
          <label class="vs-select--label">{{ $t("SpecificProduct") }}</label>
          <treeselect
            name="specificProduct"
            :multiple="false"
            :placeholder="$t('SearchSpecificProduct')"
            :async="true"
            :load-options="loadOptions"
            class="search-input"
            ref="specificProductList"
            @select="onSpecificProductSelected"
          />
        </div>
      </div>
    </form>
    <div class="vx-row" v-for="group in tempGroupOfItemsDetails" :key="group">
      <div class="vx-col w-full">
        <div class="vx-card mb-4" v-if="refresh">
          <div class="vx-card__header">
            <div class="vx-card__title w-full">
              <h4>
                {{ group.genericProductName }}
              </h4>
            </div>
          </div>
          <div class="vx-card__collapsible-content vs-con-loading__container">
            <div class="vx-card__body custom-tbl">
              <vs-table
                :data="group.configurableProductItemsQueryDto"
                ref="table"
              >
                <template slot="thead">
                  <vs-th style="width: 3%">#</vs-th>
                  <vs-th style="width: 13%">{{ $t("Name") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("PersianName") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("ItemCode") }}</vs-th>
                  <vs-th style="width: 10%">{{ $t("Action") }}</vs-th>
                </template>
                <template slot-scope="{ data }">
                  <vs-tr
                    v-for="(tr, indextr) in data"
                    :data="tr"
                    :key="indextr"
                  >
                    <vs-td :data="data[indextr]">
                      {{ parseInt(indextr) + 1 }}
                    </vs-td>
                    <vs-td :data="data[indextr].englishName">
                      {{ data[indextr].englishName }}
                    </vs-td>
                    <vs-td :data="data[indextr].persianName">
                      {{ data[indextr].persianName }}
                    </vs-td>
                    <vs-td :data="data[indextr].itemCode">
                      {{ data[indextr].itemCode }}
                    </vs-td>
                    <vs-td :data="data[indextr]">
                      <vs-button
                        radius
                        color="danger"
                        size="small"
                        type="gradient"
                        icon-pack="feather"
                        icon="icon-x"
                        @click.prevent="
                          removeItemInfo(indextr, group.genericProductId)
                        "
                        class="d-inline"
                      ></vs-button>
                    </vs-td>
                  </vs-tr>
                </template>
              </vs-table>
            </div>
          </div>
        </div>
        <div class="loadingsec pt-20 pb-20" v-if="showLoading">
          <svg
            class="spinner"
            width="65px"
            height="65px"
            viewBox="0 0 66 66"
            xmlns="http://www.w3.org/2000/svg"
          >
            <circle
              class="path"
              fill="none"
              stroke-width="6"
              stroke-linecap="round"
              cx="33"
              cy="33"
              r="30"
            ></circle>
          </svg>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <vs-button
          type="filled"
          class="float-right mb-4"
          @click.prevent="submitForm"
          :disabled="disabled"
          >{{ $t("Save") }}</vs-button
        >
      </div>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import Treeselect from "@/components/CustomTreeSelect.vue";
import { ASYNC_SEARCH } from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";

export default {
  data() {
    return {
      configurableProductId: null,
      showLoading: false,
      refresh: true,
      tempGroupOfItemsDetails: [],
      disabled: false,
      model: {
        configurableProductId: null,
        configurableProductItemsCommand: [],
      },
      searchQueryNew: "",
      searchQueryOld: "",
    };
  },
  computed: {
    ...mapGetters({
      groupOfItemsDetails: "configurableProducts/groupOfItemsDetails",
    }),
  },
  mounted() {
    this.configurableProductId = this.$route.params.id;
    this.load();
    this.model.configurableProductId = this.configurableProductId;
  },
  methods: {
    ...mapActions({
      fetchSpecificProductsSearch: "specificProduct/fetchSearch",
      fetchGroupOfItems: "configurableProducts/fetchGroupOfItems",
      assignItemInfo: "configurableProducts/assignItemInfo",
    }),
    load() {
      this.fetchGroupOfItems(this.configurableProductId).then(() => {
        this.tempGroupOfItemsDetails = JSON.parse(
          JSON.stringify(this.groupOfItemsDetails)
        );
      });
    },
    loadOptions({ action, searchQuery, callback }) {
      this.searchQueryNew = searchQuery;
      this.searchQueryOld = this.searchQueryNew;
      setTimeout(() => {
        this.searchQueryNew = searchQuery;
        if (this.searchQueryOld == this.searchQueryNew) {
          if (action === ASYNC_SEARCH) {
            this.fetchSpecificProductsSearch(searchQuery).then((r) => {
              const options = [];
              r.forEach(function (element) {
                options.push({
                  id: element.id,
                  label:
                    element.persianName +
                    "-" +
                    element.productColorName +
                    "-" +
                    element.warrantyName +
                    " ---کدکالا : " +
                    element.itemCode,
                  englishName: element.persianName,
                  itemCode: element.itemCode,
                  persianName: element.persianName,
                  specificProductId: element.id,
                  genericProductId: element.genericProductId,
                });
              });
              callback(null, options);
            });
          }
        }
      }, 2000);
    },
    onSpecificProductSelected(data) {
      if (data) {
        if (
          this.tempGroupOfItemsDetails.filter(
            (x) => x.genericProductId === data.genericProductId
          )[0]
        ) {
          var sameGenericConfigurableProductItems =
            this.tempGroupOfItemsDetails.filter(
              (x) => x.genericProductId === data.genericProductId
            )[0].configurableProductItemsQueryDto;
          if (sameGenericConfigurableProductItems != null) {
            var alreadyExisted = sameGenericConfigurableProductItems.findIndex(
              (x) => x.specificProductId == data.specificProductId
            );
            if (alreadyExisted === -1) {
              sameGenericConfigurableProductItems.push({
                englishName: data.englishName,
                itemCode: data.itemCode,
                persianName: data.persianName,
                specificProductId: data.specificProductId,
                genericProductId: data.genericProductId,
              });
            } else {
              this.$swal({
                position: "center-center",
                type: "warning",
                text: "کالا با این آیتم کد در لیست انتخابی از قبل موجود است!",
                showConfirmButton: false,
                timer: 8000,
              });
            }
          } else {
            this.tempGroupOfItemsDetails.filter(
              (x) => x.genericProductId === data.genericProductId
            )[0].configurableProductItemsQueryDto = [
              {
                englishName: data.englishName,
                itemCode: data.itemCode,
                persianName: data.persianName,
                specificProductId: data.specificProductId,
                genericProductId: data.genericProductId,
              },
            ];
          }
          this.$refs.specificProductList.clear();
        } else {
          this.$swal({
            position: "center-center",
            type: "error",
            text: "برای آیتم انتخاب شده دسته‌ای جهت تخصیص یافت نشد.!",
            showConfirmButton: false,
            timer: 8000,
          });
          this.$refs.specificProductList.clear();
        }
      }
    },
    addItemInfo() {
      this.assignItemInfo(this.model)
        .then(() => {
          this.$vs.notify({
            title: "عملیات موفق",
            text: "رکورد مورد نظر با موفقیت اضافه شد!",
            color: "success",
          });
          this.refresh = false;
          this.showLoading = true;
          this.load();
          setTimeout(() => {
            this.refresh = true;
            this.showLoading = false;
          }, 1000);
        })
        .catch(() => {
          this.refresh = false;
          this.showLoading = true;
          this.load();
          setTimeout(() => {
            this.refresh = true;
            this.showLoading = false;
          }, 1000);
        });
    },
    removeItemInfo(indextr, groupGenericProductId) {
      this.tempGroupOfItemsDetails
        .filter((x) => x.genericProductId === groupGenericProductId)[0]
        .configurableProductItemsQueryDto.splice(indextr, 1);
    },
    submitForm() {
      this.disabled = true;
      this.model.configurableProductItemsCommand = [];
      var configurableProductItemsCommand =
        this.model.configurableProductItemsCommand;
      this.tempGroupOfItemsDetails.forEach(function (element) {
        if (element.configurableProductItemsQueryDto != null) {
          element.configurableProductItemsQueryDto.forEach(function (item) {
            configurableProductItemsCommand.push({
              specificProductId: item.specificProductId,
            });
          });
        }
      });
      this.assignItemInfo(this.model).then(() => {
        this.refresh = false;
        this.showLoading = true;
        this.load();
        setTimeout(() => {
          this.refresh = true;
          this.showLoading = false;
        }, 1000);
      });
      this.disabled = false;
    },
  },
  components: {
    Treeselect,
  },
};
</script>
